

import CheckList from "./CheckList.js";
import CheckListMap from "./CheckListMap.js";

import ChecklistResultsDomain from "@/domain/model/checklist/result/ChecklistResultsDomain.js";
import { SubDomain } from "../SubDomain";
import CheckListItemsDomain from "./item/CheckListItemsDomain.js";

export default class CheckListsDomain extends SubDomain {
  
  constructor(domain, storeMap) {
    super(domain, CheckList.MODEL_NAME);
    this._storage = storeMap.CheckListStorage;
    this._items = new CheckListItemsDomain(domain, storeMap);
    this._results = new ChecklistResultsDomain(domain, storeMap);
  }

  list() {
    return this._storage.list;
  }
  
  items() {
    return this._items;
  }
  
  results() {
    return this._results;
  }
  
  findById(objId) {
    var object = this._storage.map[objId];
    return new CheckList(this.domain, object);
  }
  
  findByCompany(company) {
    var objects = this.list();
    var map = new CheckListMap(this.domain);
    let checklist = null;
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      checklist = new CheckList(this.domain, item);
      if (checklist.company().idEquals(company)) {
        map.add(checklist);
      }
    }
    return map;
  }

  findAll() {
    var objects = this.list();
    var map = new CheckListMap(this.domain);
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      var checklist = new CheckList(this.domain, item);
      map.add(checklist);
    }

    return map;
  }

}